import { types } from 'mobx-state-tree';


const SEWAGE_TYPES = {
    HOLDING_TANK: 'holding-tank',
    MUNICIPAL: 'municipal',
    SEPTIC: 'septic',
};

const SewageTypeEnum = types.enumeration('SewageType', Object.values(SEWAGE_TYPES));

export {
    SewageTypeEnum,
};
export default SEWAGE_TYPES;
